/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: SummaryofSalesbyQuarterModule
 * Purpose		: Module for SummaryofSalesbyQuarter.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { NgModule }       from '@angular/core';
import { CommonModule }   from '@angular/common';
import { FormsModule }    from '@angular/forms';
import { SharedModule } from '../shared/Shared.module';

import { SummaryofSalesbyQuarterService } from './SummaryofSalesbyQuarter.service';
import { SummaryofSalesbyQuarterListComponent } from './SummaryofSalesbyQuarterList.component';
import { SummaryofSalesbyQuarterSearchComponent } from './SummaryofSalesbyQuarterSearch.component';
import { SummaryofSalesbyQuarterDetailsComponent } from './SummaryofSalesbyQuarterDetails.component';

import { SummaryofSalesbyQuarterRoutingModule } from './SummaryofSalesbyQuarter-routing.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
	SharedModule,
    SummaryofSalesbyQuarterRoutingModule
  ],
  declarations: [
    SummaryofSalesbyQuarterListComponent,
	SummaryofSalesbyQuarterSearchComponent,
	SummaryofSalesbyQuarterDetailsComponent
  ],
  providers: [
    SummaryofSalesbyQuarterService
  ]
})

export class SummaryofSalesbyQuarterModule { }



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/SummaryofSalesbyQuarter/SummaryofSalesbyQuarter.module.ts